module.exports = __webpack_public_path__ + "images/athlon4d058009bfd771cbb3d46582418e6ca4.png";